import { CardSchema } from '@/types/cards/card-types';
import {
  CheckCircleOutlined,
  ClockCircleOutlined,
  CreditCardOutlined,
  ShoppingCartOutlined,
} from '@ant-design/icons';

// Card type from API: schema uses `type`, some responses use `card_type`. Normalize for stats/display.
const cardType = (item: CardSchema) => (item.type ?? item.card_type ?? '').toLowerCase();

// Overview statistics
export const stats = (cardData: CardSchema[]) => [
  {
    title: 'Physical Cards',
    value:
      cardData?.filter((item) => cardType(item) === 'physical').length || 0,
    icon: <CreditCardOutlined style={{ color: '#1890ff' }} />,
    color: '#1890ff',
  },
  {
    title: 'Virtual Cards',
    value: cardData?.filter((item) => cardType(item) === 'virtual').length || 0,
    icon: <CreditCardOutlined style={{ color: '#722ed1' }} />,
    color: '#722ed1',
  },
  {
    title: 'Pending Collection',
    value:
      cardData?.filter((item) => item.status === 'pending-collection').length ||
      0,
    icon: <ClockCircleOutlined style={{ color: '#faad14' }} />,
    color: '#faad14',
  },
  {
    title: 'Issued Cards',
    value: cardData?.filter((item) => item.status === 'issued').length || 0,
    icon: <CheckCircleOutlined style={{ color: '#52c41a' }} />,
    color: '#52c41a',
  },
  {
    title: 'Dispatched Cards',
    value: cardData?.filter((item) => item.status === 'dispatched').length || 0,
    icon: <ShoppingCartOutlined style={{ color: '#ff4d4f' }} />,
    color: '#ff4d4f',
  },
];
